/**
 * Generated from ch6_p11.fla
 */
export function ch6_p11(this: Ich6_p11) {
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain2.call(rain[0] as Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain2);
		rain[0].x = 816.25;
		rain[0].y = 383.5;
		rain[0].width = 1632.50;
		rain[0].height = 767.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain1.call(rain[1] as Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain1);
		rain[1].x = 805.25;
		rain[1].y = 387.5;
		rain[1].width = 1600.50;
		rain[1].height = 759.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const horse = this.horse;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_horse.call(this.horse);
	horse.x = 641.75;
	horse.y = 768;
	horse.width = 607.50;
	horse.height = 644.50;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const holly = this.holly;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_holly.call(this.holly);
	holly.x = 868.75;
	holly.y = 768;
	holly.width = 208.50;
	holly.height = 571.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const tyler = this.tyler;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_tyler.call(this.tyler);
	tyler.x = 1087.25;
	tyler.y = 768;
	tyler.width = 316.50;
	tyler.height = 652.00;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const frameRight = this.frameRight;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 353.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframerline.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 589;
	linesRight.width = 92.50;
	linesRight.height = 322.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 1;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframelline.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 660;
	linesLeft.width = 123.00;
	linesLeft.height = 216.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_bg(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p11_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_horse(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p11_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_holly(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p11_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_tyler(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p11_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain2(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain1(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeRframe(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframerline(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframerline) {
	if (this.setLayoutTexture) this.setLayoutTexture("rline", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeLframe(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframelline(this: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframelline) {
	if (this.setLayoutTexture) this.setLayoutTexture("lline", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p11Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p11Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p11Sprite extends Ich6_p11Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p11Text extends Ich6_p11Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p11Polygon extends Array<number> {
}
interface Ich6_p11 {
	readonly rain: Ich6_p11Array<Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain2|Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_bg;
	readonly horse: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_horse;
	readonly holly: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_holly;
	readonly tyler: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_tyler;
	readonly frameRight: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeRframe;
	readonly linesRight: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframerline;
	readonly frameLeft: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeLframe;
	readonly linesLeft: Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframelline;
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_bg extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_horse extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_holly extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_tyler extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain2 extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetrainoverlayrain1 extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeRframe extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframerline extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframeLframe extends Ich6_p11Sprite {
}
interface Ich6_p11_hh_ch6_72dpi_p11psdAssetchp6_p11_wcframelline extends Ich6_p11Sprite {
}
